module.exports = (__webpack_require__(0))(213);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/ItemView.js from dll-reference girder_lib
// module id = 56
// module chunks = 0